import DataHandlerService from "@/services/data";
import AuthService from "@/services/auth";

import Popper from 'vue-popperjs';
import swal from 'sweetalert';
import 'vue-popperjs/dist/vue-popper.css';

import router from '@/router';

const data = new DataHandlerService();
const auth = new AuthService();

export default {
  name: "navbar",
  props: ["isCircle", "circleState", "canUserCreateContent", "CIRCLE_STATES"],
  components: { "popper": Popper },
  data() {
    return {
      user: data.getUserData(),
      hamburgerOpened: false,
      popperOptions: {
        placement: 'top',
        modifiers: { offset: { offset: '20px,5px' } }
      },
      searchQuery: ''
    };
  },
  computed: {
    showNewTopicLink: function() {
      return (
        this.$props.isCircle && this.$props.canUserCreateContent && this.$props.circleState === this.$props.CIRCLE_STATES[2]
      );
    },
    isFeedPage: function() {
      return router.currentRoute.name === 'feed';
    }
  },
  mounted() {
    this.sideMenu = document.getElementById("sideMenu");
    this.contentWrap = document.getElementById("contentWrap");
    this.toggleButton = document.getElementById("toggleSideButton");
  },
  created() {
    this.$root.$on("ClearSearchQuery", () => this.clearSearch());
    this.$root.$on("SaveModifiedProfile", profile => {
      if (profile._id === this.user._id) {
        this.user = profile;
      }
    });
  },
  methods: {
    toggleSide(e) {
      this.hamburgerOpened = !this.hamburgerOpened;
      this.sideMenu.classList.toggle("sidemenu-visible");
      this.contentWrap.classList.toggle("sidemenu-visible");
    },
    spawnStateChangeInCirclePage(emittedState) {
      this.$emit("stateChangeFromNav", emittedState);
    },
    logOut() {
      swal({
          text: 'Are you sure you want to log out?',
          icon: "warning",
          buttons: true,
          dangerMode: true
      }).then((willLogOut) => {
        if (willLogOut) {
          auth.logout();
        }
      });
    },
    clearSearch() {
      this.searchQuery = '';
      this.$root.$emit('searchQueryChange', '');
    },
    searchCircles() {
      this.$root.$emit('searchQueryChange', this.searchQuery);
    }
  }
};
